import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Events, ViewController, ModalController, LoadingController } from 'ionic-angular';
import moment from 'moment';
import { CoReserveTimelineComponent } from '../../components/co-reserve-timeline/co-reserve-timeline';
import { CoReserveCalendarComponent } from '../../components/co-reserve-calendar/co-reserve-calendar';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { AppState } from '../../config/state';
import { CoCalendarComponent } from '../../components/co-calendar/co-calendar';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoLoginComponent } from '../../components/co-login/co-login';
import { CoPopoverStaffSignOutComponent } from '../../components/co-popover-staff-sign-out/co-popover-staff-sign-out';
import { PatronProvider } from '../../providers/patron/patron';
import { CoStaffPinComponent } from '../../components/co-staff-pin/co-staff-pin';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { TimeoutProvider } from '../../providers/timeout/timeout';

/**
 * Generated class for the CoRoomDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-room-details',
  templateUrl: 'co-room-details.html'
})
export class CoRoomDetailsPage {
  mode: string;
  room: any;
  bookingTypes: any;
  userClassId: number;
  currentDay: any;
  previousPage: any;
  allLocations: any;
  roomLocation: any;
  didGetLocation: boolean = false;
  showRoomDetails: boolean = false;
  chosenAssets: any = {};
  chosenLayout: any;
  assetTotalCost: number = 0;
  reserveStartTime: any;
  reserveEndTime: any;
  readyToBook: boolean = false;
  reservationLengthHour: any = 0;
  reservationLengthMinutes: any = 0;
  currentCart: any;
  viewType: any;
  isCostEnabled: any;
  timeConflict: boolean = false;
  layoutChosen: boolean = false; //to uncheck inputs
  isRoomBookable: boolean;
  clientKeyword: any;
  headerLogoLink: any;
  bookingTimeRangeAllowed: {nearest: boolean, furthest: boolean} = {nearest: true, furthest: true};
  todaysDate: any;
  locationClosed: boolean = true;
  finalTotalCost: number = 0;
  currentDayOnly: boolean;
  roomAssets: any = [];
  enableBackButton: boolean = true;
  currentlyBookedByPatron: boolean = false;
  @ViewChild(CoReserveTimelineComponent) innerTimeline: CoReserveTimelineComponent
  menuSide: string = "left";
  pageTitle: string = '';
  isRootPage: boolean = false;
  isModal: boolean;
  reservationSignedIn: number;
  earlySignInTime: number;
  isStaff: boolean = false;
  distanceUnit: string = "ft";
  areaUnit: string = "sq. ft";
  useCalendarDays: boolean = true;
  constructor(public navParams: NavParams, public popoverCtrl: PopoverController, public state: AppState, private events: Events, private viewCtrl : ViewController, private timeout : TimeoutProvider, private modalCtrl: ModalController, private patronProvider: PatronProvider, private reserveProvider: ReserveProvider, private loading: LoadingController, private toast: ToastAlertsProvider, private _appState: AppState, private clientDetails: ClientDetailsProvider) {
    this.room = navParams.data.room;
    this.isStaff = _appState.staff;
    this.isRoomBookable = navParams.data.room.bookable;
    this.currentDay = navParams.data.currentDay;
    this.previousPage = navParams.data.previousView;
    this.allLocations = navParams.data.locations;
    this.currentCart = this.previousPage.currentCart;
    this.isCostEnabled = navParams.data.isCostEnabled;
    this.clientKeyword = navParams.data.clientDetails.keyword;
    this.headerLogoLink = navParams.data.headerLogo;
    this.currentDayOnly = navParams.data.currentDayOnly;
    this.pageTitle = navParams.data.pageTitle;
    this.isModal = navParams.data.isModal || false;
    this.enableBackButton = false;
    this.showRoomDetails = navParams.data.expandRoomDetails;
    // console.log(this.isCostEnabled);
    this.roomLocation = this.getCurrentLocation(this.room, this.allLocations);
    this.viewType = state.mode;
    this.mode = navParams.data.mode;
    this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
    this.checkIfInReserveRange();
    this.menuSide = this.state.burgerMenu.menuSide;
    this.events.subscribe('timeoutCalled', () => this.goBack() );
    this.getUserClasses();
  }

  ngOnInit() {
    this.clientDetails.load().then( (res) => {
      this.useCalendarDays = res.settings.rooms_calendar_day_restrictions;
      this.earlySignInTime = res.settings.rooms_early_signin_minutes;
      if(res.settings.client_use_metric) {
        this.distanceUnit = "m";
        this.areaUnit = "sq. m";
      }
      if(this._appState.reserveSignIn) this.checkForReservation();
    });
    if(!this.state.staff && this.state.sharedScreen && this.state.timeoutEnabled) {
      this.timeout.changeTimeout(this.state.timeoutInterval, true, this.state.timeoutWarning);
      this.timeout.resetTimeout();
    }
  }

  getUserClasses() {
    if (this.isStaff) {
      this.clientDetails.userClasses().then((data) => {
        this.bookingTypes = data;
      }, (error) => {
        console.log("error getting user classes");
      });
    }
  }

  goBack() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  nextDay() {
    this.currentDay = moment(this.currentDay).add(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.goToDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.checkReadyToBook();
  }

  previousDay() {
    if (moment(this.currentDay).format("YYYY-MM-DD") === moment(this.todaysDate).format("YYYY-MM-DD")) {
      return;
    }
    this.currentDay = moment(this.currentDay).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.goToDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.checkReadyToBook();
  }

  getCurrentLocation(room, locations) {
    let currentLocation;
    currentLocation = locations.filter((location) => {
      return room.locationId === location.id;
    });
    this.didGetLocation = true;

    return currentLocation[0];
  }

  roomMaxCapacity() {
    return Math.max(this.room.capacityChairs, this.room.capacityStanding, this.room.capacityTables);
  };

  toggleRoomDetails() {
    // document.getElementById("roomDetails").classList.toggle("hidden");
    if (this.showRoomDetails) {
      this.showRoomDetails = false;
    } else {
      this.showRoomDetails = true;
    }
  };

  onChange(event, cost) {
    if (event.value) {
      this.assetTotalCost += cost;
      this.calculateFinalTotalCost();
    } else if (!event.value) {
      this.assetTotalCost -= cost;
      this.calculateFinalTotalCost();
    } else {
      console.log('error calculating cost');
    }
  }

  async addToBasket() {
    if (this.timeConflict) {
      console.log('error, time conflict detected');
      return;
    }
    await this.viewCtrl.dismiss().catch(err=>{});
    this.addItemToBasket(false);
  }

  async reserveNow() {
    if (this.timeConflict) {
      console.log('error, time conflict detected');
      return;
    }
    if (this.mode === 'multi') {
      await this.viewCtrl.dismiss().catch(err=>{});
    }
    await this.addItemToBasket(true);
    await this.previousPage.goToCart('', true);
  }

  async addItemToBasket(checkout) {
    let newItem: any = {};
    if (await !this.checkReadyToBook()) {
      return;
    }
    newItem.room = this.room;
    newItem.reserveStartTime = this.reserveStartTime;
    newItem.reserveEndTime = this.reserveEndTime;
    newItem.assetTotalCost = this.assetTotalCost;
    newItem.chosenAssets = [];
    newItem.roomLocation = this.roomLocation;
    newItem.totalPrice = this.calculateFinalTotalCost();
    newItem.reservationPrice = this.calculateFinalTotalCost(true);
    newItem.reservationLength = this.buildReservationLengthString(this.reserveStartTime, this.reserveEndTime);
    this.roomAssets.forEach((element) => {
      if (this.chosenAssets[element.id]) {
        newItem.chosenAssets.push(element);
      }
    });

    if (this.room.layouts.length > 0) {
      newItem.chosenLayout = this.chosenLayout;
    }

    // if (!checkout) {
      // this.toast.triggerToast("Reservation added to cart!", '');
    // }
    this.previousPage.addToCart(newItem);
  }

  calculateFinalTotalCost(justReservationCost?) {
    if (this.room.roomChargePeriod === 'Per block') {
      let reserveStart, reserveEnd, lengthInMinutes, segmentSizeInMinutes, segmentsPerBlock, timePerCharge, costPerTime;
      reserveStart = this.reserveStartTime;
      reserveEnd = this.reserveEndTime;
      lengthInMinutes = moment(reserveEnd).diff(reserveStart, 'minutes');
      segmentSizeInMinutes = this.room.segmentSizeInMinutes;
      segmentsPerBlock = this.room.segmentsPerBlock;
      timePerCharge = segmentSizeInMinutes * segmentsPerBlock;
      costPerTime = this.room.roomCharge;

      let costMultiplier = lengthInMinutes/timePerCharge;
      let bookingCost = costMultiplier * costPerTime;
      let assetTotalCost = this.assetTotalCost;

      if (justReservationCost) {
        this.finalTotalCost = bookingCost;
        return bookingCost;
      }

      this.finalTotalCost = bookingCost + assetTotalCost;
      return bookingCost + assetTotalCost;
    } else {
      // let bookingCost = this.room.roomCharge;
      // let assetTotalCost : number = 0;
      return this.room.roomCharge + this.assetTotalCost;
    }
  }

  updateTimes(times) {
    this.reserveStartTime = times[0];
    this.reserveEndTime = times[1];
    this.locationClosed = false;

    if (times[0] === undefined && times[1] === undefined) {
      this.reservationLengthHour = 0;
      this.reservationLengthMinutes = 1;
      if (times[2] && times[2] === 'closed') {
        this.locationClosed = true;
        this.timeConflict = true;
      }
      return;
    }

    this.reservationLengthHour = moment(times[1]).diff(times[0], "hours");
    this.reservationLengthMinutes = moment(times[1]).diff(times[0], "minutes") - (this.reservationLengthHour * 60);
    if (this.reservationLengthHour === 0) {
      this.reservationLengthHour = 1;
    }

    this.calculateFinalTotalCost();
    this.checkReadyToBook();
  }

  updateConflict(conflict) {
    this.timeConflict = conflict;
  }

  checkIfInReserveRange() {
    const now = moment();

    // Check nearest booking limit using start time
    let isNearestOk = true;
    if (this.room.bookingLimits.nearestBookingInDays !== 0) {
      const bookingStartDateTime = this.reserveStartTime || this.currentDay;
      const targetStart = moment(bookingStartDateTime);

      let nearestLimit: moment.Moment;
      if (this.useCalendarDays) {
        nearestLimit = moment(now).add(this.room.bookingLimits.nearestBookingInDays, 'days').startOf('day');
      } else {
        nearestLimit = moment(now).add(this.room.bookingLimits.nearestBookingInDays, 'days');
      }

      if (targetStart.isBefore(nearestLimit)) {
        isNearestOk = false;
      }
    }

    // Check furthest booking limit using end time
    let isFurthestOk = true;
    if (this.room.bookingLimits.furthestBookingInDays > 0) {
      const bookingEndDateTime = this.reserveEndTime || this.currentDay;
      const targetEnd = moment(bookingEndDateTime);

      let furthestLimit: moment.Moment;
      if (this.useCalendarDays) {
        furthestLimit = moment(now).add(this.room.bookingLimits.furthestBookingInDays, 'days').endOf('day');
      } else {
        furthestLimit = moment(now).add(this.room.bookingLimits.furthestBookingInDays, 'days');
      }

      if (targetEnd.isAfter(furthestLimit)) {
        isFurthestOk = false;
      }
    }

    // Set values once at the end
    this.bookingTimeRangeAllowed.nearest = isNearestOk;
    this.bookingTimeRangeAllowed.furthest = isFurthestOk;
  }

  openCalendar(event) {
    let popover = this.popoverCtrl.create(CoReserveCalendarComponent, { reservePage: this, currentDay: this.currentDay }, { cssClass: 'reserve-calendar-popover' });
    popover.present({
      ev: event
    });
  }
  openDatePicker(){
    let popover = this.popoverCtrl.create(CoCalendarComponent, { popup: true, range: false }, { cssClass: 'date-time-popover' });
    popover.present();

    popover.onDidDismiss(data => {
      if(data && data.date){
				this.goToDate(data.date);
      }
    });
  }

  goToDate(date) {
    this.currentDay = date;
    this.currentDay = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.goToDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
  }

  checkReadyToBook() {
    this.checkIfInReserveRange();
    if (this.reserveStartTime && this.reserveEndTime) {
      if (this.room.layouts.length > 0 && !this.chosenLayout) {
        this.readyToBook = false;
        return false;
      }
      this.readyToBook = true;
      return true;
    }
    else {
      this.readyToBook = false;
      return false;
    }
  }

  changeLayout(layout) {
    this.chosenLayout = layout;
    this.innerTimeline.selectedLayout = layout;
    this.innerTimeline.applySetupBreakdownTime();
    this.innerTimeline.checkForConflicts();
    this.checkReadyToBook();
  }

  goToCart(event) {
    this.previousPage.goToCart(event, false, true);
  }

  buildReservationLengthString(startTime, endTime) {
    let hour, minute;

    hour = moment(endTime).diff(startTime, "hours");
    minute = moment(endTime).diff(startTime, "minutes");
    if (hour > 0) {
      minute = minute - (hour * 60);
    }

    let finalString: string = "";

    if (hour === 1) {
      finalString = "1 hour";
    }
    else if (hour > 1) {
      finalString = `${hour} hours`;
    }

    if (minute === 1) {
      if (finalString === "") {
        finalString = "1 minute";
      }
      else {
        finalString += " 1 minute";
      }
    }
    else if (minute > 1) {
      if (finalString === "") {
        finalString = `${minute} minutes`;
      }
      else {
        finalString += ` ${minute} minutes`;
      }
    }
    this.reservationLengthHour = hour;

    if (hour === 0) {
      this.reservationLengthHour = 1;
    }
    return finalString;
  }

  async resetTimeline() {
    this.chosenLayout = undefined;
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.layoutChosen = false;
    await this.innerTimeline.resetTimeline();
    this.innerTimeline.selectedLayout = undefined;
    this.chosenAssets = {};
    this.roomAssets = [];
    this.checkReadyToBook();
    if(this.mode === 'single') {
      this.currentCart = [];
      this.previousPage.emptyCart();
    }
  }

  updateAssets(assets) {
    this.roomAssets = assets;
    this.roomAssets.forEach((asset) => {
      this.chosenAssets[asset] = false;
    });
  }

  checkForReservation() {
    this.reservationSignedIn = -1;
    this.reserveProvider.getReservations(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), this.room.id).then( (reservations) => {
      for(let r of reservations) {
        const signInAt = moment(r.startTime).subtract(this.earlySignInTime, 'minutes');
        if(moment().isBetween(signInAt, moment(r.endTime)) && r.status === 'approved') {
          this.reservationSignedIn = r.noShow;
        }
      }
    });
  }

  patronSignIn() {
    let modal = this.modalCtrl.create(CoLoginComponent, { dismissButton: 'close', login: (barcode, pin) => this.patronProvider.getSummaryDetails(barcode, pin) }, { cssClass: `loginModalBase`, enableBackdropDismiss: false });
    modal.present();
    modal.onDidDismiss(res => {
      if (res && res.id){
        let loader = this.loading.create({
          content: 'Signing in',
        });
        loader.present();
        this.reserveProvider.signInForReservation(res.barcode, res.pin, this.room.id).then( res => {
          loader.dismiss();
          if(res.signIn && res.signIn.success) {
            this.toast.showAlert('', 'You have signed in for your reservation', 'success', 10000);
            this.viewCtrl.dismiss().catch(err => { });
          }
          else if(res.signIn && res.signIn.message) {
            this.toast.showAlert('', res.signIn.message, 'warning', 10000);
          }
          else {
            this.toast.showAlert('', 'There was a problem signing in for your reservation.', 'warning', 10000);
          }
        }).catch( () => {
          loader.dismiss();
        });
      }
    });
  }

  patronSignOut() {
    let modal = this.modalCtrl.create(CoLoginComponent, { dismissButton: 'close', login: (barcode, pin) => this.patronProvider.getSummaryDetails(barcode, pin) }, { cssClass: `loginModalBase`, enableBackdropDismiss: false });
    modal.present();
    modal.onDidDismiss( res => {
      if (res && res.id){
        let loader = this.loading.create({
          content: 'Signing out...',
        });
        loader.present();
        this.reserveProvider.patronEndReservation(res.barcode, res.pin, this.room.id).then( res => {
          loader.dismiss();
          if(res.signOut&& res.signOut.success) {
            this.toast.showAlert('', 'You have signed out of your reservation', 'success', 10000);
          }
          else if(res.signOut && res.signOut.message) {
            this.toast.showAlert('', res.signIn.message, 'warning', 10000);
          }
          else {
            this.toast.showAlert('', 'There was a problem signing out of your reservation', 'warning', 10000);
          }
          this.viewCtrl.dismiss().catch(err=>{});
        }).catch( () => {
          loader.dismiss();
        });
      }
    });
  }

  staffSignOut() {
    let modal = this.modalCtrl.create(CoStaffPinComponent);
    modal.present();
    modal.onDidDismiss( pin => {
      if(pin) {
        this.reserveProvider.staffEndReservation(parseInt(pin), this.room.id).then( res => {
          if(res.signOut && res.signOut.success) {
            this.toast.showAlert('', 'Signed out', 'success', 5000);
          }
          else if(res.signOut && res.signOut.message) {
            this.toast.showAlert('', res.signOut.message, 'warning', 5000);
          }
          else {
            this.toast.showAlert('', 'There was a problem signing out of the reservation.', 'warning', 5000);
          }
        });
      }
    });
  }

  staffSignOutPopover(e) {
    const popover = this.popoverCtrl.create(CoPopoverStaffSignOutComponent, { roomId: this.room.id }, { cssClass: 'staffSignOutPopover' });
    popover.present({
      ev: e,
      animate: false
    });
    popover.onDidDismiss( signOut => {
      if(signOut) {
        this.staffSignOut();
      }
    });
  }

  async updateRoom() {
    await this.reserveProvider.getRooms(
      this.room.locationId,
      this.currentDay,
      this.room.id,
      this.userClassId
    ).then((res) => {
      this.room = res[0];
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-room-details/co-room-details.ts